import { ToastVariant } from "./toastItem";

type ToastHandler = (
    message: string,
    variant: ToastVariant,
    duration?: number,
    isAnnouncement?: boolean
) => void;

class ToastService {
    private handler: ToastHandler | null = null;

    register(handler: ToastHandler) {
        if (this.handler) {
            return;
        }
        this.handler = handler;
    }

    isRegistered() {
        return this.handler !== null;
    }

    success(message: string | undefined, duration?: number) {
        this.handler?.(message ?? "", "success", duration);
    }

    error(message: string | undefined, duration?: number) {
        this.handler?.(message ?? "", "error", duration);
    }

    warning(message: string | undefined, duration?: number, isAnnouncement?: boolean) {
        this.handler?.(message ?? "", "warning", duration, isAnnouncement);
    }

    info(message: string | undefined, duration?: number) {
        this.handler?.(message ?? "", "info", duration);
    }
}

export const toastService = new ToastService();

